export default __webpack_public_path__ + "static/media/PHP_-_adamr.space___Codecademy.cc54d74e.pdf";